import {
  SET_EMERGENCY_CONTACT_FORM,
  SET_EMERGENCY_CONTACT_FORM_FIELD
} from './actionTypes'

export const setEmergencyContactForm = data => {
  return {
    type: SET_EMERGENCY_CONTACT_FORM,
    data
  }
}

export const setEmergencyContactFormField = (field, value) => {
  return {
    type: SET_EMERGENCY_CONTACT_FORM_FIELD,
    field,
    value
  }
}
